// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { desktop16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-desktop': IconDesktop;
    }
}

/**
 * The icon component for the 'desktop' icon
 */
export class IconDesktop extends Icon {
    public constructor() {
        super(desktop16X16);
    }
}

registerIcon('icon-desktop', IconDesktop);
export const iconDesktopTag = 'nimble-icon-desktop';
